module.exports = __webpack_public_path__ + "img/icon-edit_white.baabc627.svg";